module.exports = __webpack_public_path__ + "img/58.f229cc19.jpg";